import * as types from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

/**
 * @returns {State}
 */
const set = (_, { payload }) => payload;

/**
 * @returns {State}
 */
const reset = () => initialState;

export default createReducer(initialState, {
  [types.SET_EDITED_TIRE]: set,
  [types.RESET_EDITED_TIRE]: reset,
});
